import { Box } from '@mui/material';
import { StrictMode, Suspense } from 'react'
import { createRoot } from 'react-dom/client'
import { BrowserRouter, Route, Routes } from "react-router-dom";
import MuiThemeProvider from './theme/MuiThemProvider';
import { PAGE_LIST } from './enums/pageEnums';
import { TopBar } from './components/topBar/TopBar';
import { EmailDialog } from './components/generic/EmailDialog';
import ScrollToTop from './components/ScrollToTop';
import { Footer } from './components/footer/Footer';
import { NotFoundPage } from './pages/NotFoundPage';
import { HelmetProvider } from 'react-helmet-async';
import PageFallback from './components/generic/PageFallback';
import WaveDisrupt from './components/WaveDisrupt';

createRoot(document.getElementById('root')).render(
  <StrictMode>
    <HelmetProvider>
      <MuiThemeProvider>
        <WaveDisrupt />
        <BrowserRouter>
          <ScrollToTop />
          <TopBar />
          <Box component="main">
            <Suspense fallback={<PageFallback />}>
              <Routes>
                {
                  PAGE_LIST?.map((page, index) => {
                    return (
                      <Route key={`page-key-${index}`} path={page?.path} element={page?.component} />
                    )
                  })
                }
                <Route path="*" element={<NotFoundPage />} />
              </Routes>
            </Suspense>
          </Box>
          <Footer />
        </BrowserRouter>
        <EmailDialog />
        {/* <Chatbot /> */}
      </MuiThemeProvider>
    </HelmetProvider>
  </StrictMode>
)
